// extracted by mini-css-extract-plugin
export default {"title":"Electricity_title__-UQj1","frame":"Electricity_frame__K4RMf","text":"Electricity_text__few-B","div":"Electricity_div__f2f+w"};